export const hasPermission = (role, permission) => {
    return role?.permissions?.includes(permission);
};
export const hasSomePermission = (role, permissions) => {
    return permissions.some((p) => hasPermission(role, p));
};
export const hasAllPermissions = (role, permissions) => {
    return permissions.every((p) => hasPermission(role, p));
};
//# sourceMappingURL=hasPermission.js.map